<div class="swd-form-inline-control">
  <div class="swd-form-label">{{ 'common.language' | translate }}</div>
  <p-select
    [options]="languagesList"
    [(ngModel)]="selectedLanguage"
    (ngModelChange)="setLang($event)"
    name="languages"
    styleClass="swd-dropdown swd-dropdown--small">
    <ng-template
      #selectedItem
      let-lang>
      <div class="language__selected">
        <i class="pi pi-globe"></i>
        &nbsp;{{ lang.value | uppercase }}
      </div>
    </ng-template>
  </p-select>
</div>
